import { componentSpacing06 } from '../../../tokens';
export var headerNavigationLinks = {
  NavigationItem: {
    base: {
      paddingLeft: componentSpacing06,
      fontFamily: '$typography.paragraphMedium.fontFamily',
      fontSize: '$typography.paragraphMedium.fontSize',
      fontWeight: '$typography.paragraphMedium.fontWeight',
      letterSpacing: '$typography.paragraphMedium.letterSpacing',
      lineHeight: '$typography.paragraphMedium.lineHeight',
      color: '$typography.paragraphMedium.color'
    }
  }
};